import { combineReducers } from "redux";
import AhorroYCredito from './ahorroYCredito.reducer';

const reducer = combineReducers({
    AhorroYCredito
});

export default reducer;